import { eventBus } from "../eventbus.js";

export default {
    methods: {
        offlineLoadStart: function() {
            //CARICAMENTI DA EFFETTUARE PRIMA DI INIZIALIZZARE LA VIDEATA
            var promises = [];
            var vm = this;
            this.registry_record = null;            // ---  Flag valorizzati solo in caso di indexedDb Pre caricato
            this.registryStillToBeLoaded = false;   // ---
    
            //____________________________________________________Registry obbligatorio:____________________________________________________________________________________________
            //path relativo per evitare dipendenza dall'url attuale quando faccio loadDatabase con la http request
            var registryResolve, registryReject;
            promises.push(new Promise(function(resolve, reject) {
                registryResolve = resolve;
                registryReject = reject
            }).then((res) => {
                vm.setLoadingMessage(this.$Jed.firstUpperTranslate('registry database loaded', null)+'...')
                // promise per caricamento registry risolta all'interno dell'elaborazione dell'indexed DB
                vm.$root.dbRegistry = res;
                // a questo punto il registry è caricato e sicuramente referenziato nell'indexedDB ---> se impostato da preferenza, eseguo la sync remote
                var isThere =  vm.$root.dbRegistry.getCollection("deletions")
                if(isThere){
                    //dovrebbe esserci sempre la collezione dei record rimossi, ma nel front end devo ignorarla
                    //vm.$root.dbRegistry.removeCollection("deletions")
                }
    
                //if(vm.$root.preferences.sincro != "Disabled" && vm.$root.preferences.sincro != "Manual" && false){ 
                if(vm.$root.preferences.sincro != "Disabled" && vm.$root.preferences.sincro != "Manual"){ 
                    vm.$Sync.remoteSyncRegistry().then(() => {
                        console.log("____ SYNC RESOLVED ____")
                        //AL TERMINE... se da preferenze, la Sync del registry è differita in un intervallo, chiamo al procedura di start polling
                        //il controllo devo farlo qui, e non nella syncResolve, perchè potrei non essere Online da preferenze
                        if(vm.$root.preferences.sincro == "Deferred" && vm.$root.preferences.deferredInterval){
                            //intervallo in minuti
                            var millisec = Number(vm.$root.preferences.deferredInterval) * 1000 * 60 // (ms - s - m)
                            vm.$Sync.startSyncDefferredPolling(millisec);
                        }
                    });
                } else {  
                    // se la sincronizzazione è Manuale, e l'utente ha abilitato i suggerimenti, consiglio di eseguire la sync
                    if((vm.$root.preferences.sincro == "Manual" && vm.$root.preferences.manualSyncBell)){
                        console.log("enter")
                        var ok = function(){
                            vm.$root.manualSync();
                        }
                        var no = function(){
                        }
                        var e = {
                            message: this.$Jed.firstUpperTranslate('do you want to launch the remote sync procedure?', null),
                            ok: ok,
                            no: no
                        }
                        setTimeout(function(){
                            vm.$nextTick(function(){
                                eventBus.$emit("confirm", e)
                            })
                        },500)
                       
                    }  
                }
                syncResolve();
            }));
    
            //____________________________________________________Registry Remote Sync Forzata:____________________________________________________________________________________________
            //forzo la sync remota del registry se indicato da preferenza. Devo comunque creare la promise perchè non si è certi delle preferenze prima della loadIndexDB
            //in caso contrario, risolvo la promise nella callback delle IndexDB senza fare nulla
            var syncResolve, syncReject;
            promises.push(new Promise(function(resolve, reject) { 
                syncResolve = resolve;
                syncReject = reject
            }).then((res) => {
                vm.setLoadingMessage(this.$Jed.firstUpperTranslate('registry remote synchronization', null)+'...')
                // nessun listener, serve solo per risolvere promise.ALL con il registry sincronizzato all'ultima versione
            }));
            
            //____________________________________________________Lista catalogs obbligatori:____________________________________________________________________________________________
            //se già presenti in indexedDB, la promise si risolverà subito senza chiamate asincrone
            // la promise ritorna il riferimento all'indexedDB caricato in memoria
            var catalogsResolve, catalogsReject;
            promises.push(new Promise(function(resolve, reject) { 
                catalogsResolve = resolve;
                catalogsReject = reject
            }).then((res) =>  {
                vm.setLoadingMessage(this.$Jed.firstUpperTranslate('catalogs loaded', null)+'...') 
                // valorizzo token.catalogs nella risoluzione della promise, quando la collection catalogs è sicuramente valorizzata...
                // a prescindere dal fatto che abbia chiamato il servizio, o avessi già i valori dei cataloghi salvati su indexedDB
                var idbCatalogs = res.getCollection("catalogs")
                var arr = idbCatalogs.find();
                for(var i = 0; i < arr.length; i++){
                    var catalogToToken = {
                        id: arr[i].id,
                        version: arr[i].version,
                        date: new Date(arr[i].date).toLocaleDateString(),
                        brand : arr[i].brand,
                        name: arr[i].name,
                        file: arr[i].file
                    }
                    vm.$Configs.catalogs.push(catalogToToken)
                }
            }))
    
            //____________________________________________IndexedDB per la fruizione offline: ______________________________________________________________________________________
            //uso indexed adapter e partitioning adapter(quest'ultimo per poter gestire db superiori a 60Mb)
    
            /**
             *  creo l'indexedDb
             */
            promises.push(this.loadLoki(vm.$root.dataReferencesDbName, "indexedAdapter", true, true, 4000).then((res) => {
                /**
                 *   aggiorno messaggio nella loading page
                 */
                vm.setLoadingMessage(this.$Jed.firstUpperTranslate('local database loaded', null)+'...') 
    
                /**
                 *   gestione preferenze dell'utente
                 */
                var preferences = res.getCollection("preferences");
                if(!preferences){
                    preferences = res.addCollection("preferences");
                }
                var userID = this.$root.token.idUtente;
                console.log(preferences)
                var pref = preferences.find({"id" : userID})
                var source = null;
                if(!pref || pref.length == 0){
                    // se non sono già state settate delle preferenze per l'utente, mi copio quelle di default e salvo il record nell'indexDB
                    source = {}
                    for(var prop in front_end_configs.default_preferences){
                        source[prop] = front_end_configs.default_preferences[prop];
                    }
                    source["id"] = userID;
                    preferences.insert(source);
                    //inoltre, se previsto da behavior, mostro la schermata delle preferenze prima del caricamento catalogo
                    vm.$root["showPreferencesAfterLogin"] = false;
                    if(behav.preferencesAfterLogin){
                        this.$root.BLOCK_NAVIGATION = true;
                        vm.$root["showPreferencesAfterLogin"] = true;
                    }
                } else {
                    // altrimenti, mi tengo una copia di sessione separata dal record dell'indexDB 
                    source = pref[0];
                    // se non ho mai salvato le preferenze (ho fatto subito logout appena è apparsa la schermata), ripropongo comunque la videata
                    if(!source.savedOnce){
                        vm.$root["showPreferencesAfterLogin"] = false;
                        if(behav.preferencesAfterLogin){
                            vm.$root.BLOCK_NAVIGATION = true;
                            vm.$root["showPreferencesAfterLogin"] = true;
                        }
                    }
                }
                for(var prop in source){
                    vm.$root.preferences[prop] = source[prop];
                }
    
    
                /**
                 *   predispongo varie collection nell'indexedDB
                 */
                // 1) collection per meta-info notifiche PER OGNI UTENTE
                if (!res.getCollection("userMetaNotifications")) {
                    res.addCollection("userMetaNotifications");
                }
                // 2) collection contenente lo stato delle notifiche non eliminate DISTINTE per utente
                if (!res.getCollection("userNotifications")) {
                    res.addCollection("userNotifications");
                }
                
                // 3) collection contenente i brands
                if (!res.getCollection("brands")) {
                    res.addCollection("brands");
                }
                // 4) collection contenente i cataloghi: 
                // Conterrà i cataloghi a cui può accedere il cliente associato all'utente loggato
                // Questi cataloghi li prendo facendo la richiesta al cmd GetCatalogList
                // In questo modo, nell'indexedDb avrò i cataloghi per cui il cliente dell'utente ha i permessi.
                if (!res.getCollection("catalogs")) { 
                    res.addCollection("catalogs");
                }
    
                /**
                 *   faccio la richiesta ai service per trovare i cataloghi a cui può accedere il cliente dell'utente loggato
                 */
                vm.$root
                    .microservice({
                        role: "authentication",
                        cmd: "GetCatalogList",
                        params: {
                            idAgente: vm.$Configs.idAgente,
                            idCliente: vm.$Configs.idCliente 
                        }
                    })
                    .then(response => {
                        console.log('App.vue - GetCatalogList', response.body)
                        var catalogs = response.body,
                            cat_coll = res.getCollection('catalogs');
                        cat_coll.clear(); // svuoto la collection dei cataloghi in modo da andarla a popolare solo con i cataloghi nuovi appena tornati con la GetCatalogList
                        
                        console.log("CATALOGS EMPTIED")
                        console.log(cat_coll)
    
                        /* catalogs = [{
                           brand: "bcs",
                           date: "2018-12-05T18:42:50.931Z",
                           file: "ferrari.catalog.38.0.2018.12.05.18.42.50.931.json",
                           id: 38,
                           name: {
                               id: 38,
                               des: "FERRARI Trattori",
                               trad:[
                                   {lid: "ENG", des: "FERRARI Tractors"},
                                   {lid: "SPA", des: "FERRARI Tractores"},
                                   {lid: "TED", des: "FERRARI Traktoren"},
                                   {lid: "FRA", des: "FERRARI Tracteurs"}
                               ]},
                           version: 308
                        }] */
    
                        for(var i=0; i<catalogs.length; i++){
                            //__________________________________________________________________________________________________________________
                            //tra le traduzioni delle descrizioni dei cataloghi utilizzo quella che corrisponde alla lingua corrente
                            var traduzioni = catalogs[i].name.trad, 
                                current_lang,
                                filtered = [],
                                traduzioneIta = catalogs[i].name.des;
                            
                            current_lang = vm.$root.token.siglaLingua;
    
                            if(traduzioni && traduzioni.length>0 && current_lang != 'ITA'){
                                filtered = traduzioni.filter((t)=>{
                                    return t.lid == current_lang
                                })
                            }
                            //__________________________________________________________________________________________________________________
                            
                            var catalog = {
                                id: catalogs[i].id,
                                version: catalogs[i].version,
                                date: new Date(catalogs[i].date).toLocaleDateString(),
                                brand : catalogs[i].brand,
                                name: filtered.length>0 ? filtered[0].des : traduzioneIta,
                                file: catalogs[i].file
                            }
    
                            cat_coll.insert(catalog);
                            
                            /* var existing_catalog = cat_coll.find({
                                'id': catalog.id
                            })[0]
                            
                            if(existing_catalog){ //se c'è già, lo aggiorno
                                existing_catalog.version = catalog.version
                                existing_catalog.date = catalog.date
                                existing_catalog.name = catalog.name
                                existing_catalog.file = catalog.file
                                cat_coll.update(existing_catalog)
                            }else{ //se non c'è lo inserisco
                                cat_coll.insert(catalog)
                            } */
                            
                        }
                        console.log("CATALOGS INSERTED")
                        console.log(cat_coll)
                        catalogsResolve(res);
                    },
                    err => {
                        vm.loading_screen.finish();
                        //vedi gestione errore in main.js > microservice
                    })
                    .catch(err => {
                        console.log(err);
                        vm.loading_screen.finish();
                        var msg = err && err.body && err.body.error ? err.body.error : ''
                        vm.alertOPT.message = "Application caught an error <br> <h5>Details: " + "authentication.GetCatalogList - " + msg +'</h5>',
                        vm.alertAPI.open();
                    })						   
    
                /**
                 *   caricamento del registry e dell'IndexedDb 
                 */
                var registryCollection = res.getCollection("singleRegistry"); // collezione con un solo record per indexedDB
                if(!registryCollection){
                    registryCollection = res.addCollection("singleRegistry");
                }
                // valorizzo dataReferences prima di caricare il registry, in modo da averlo anche in un'eventuale fase di sincronizzazione
                vm.$root["dataReferences"] = res;
    
                //identificativo del registry: se non c'è, è la prima volta che carico il registry nell'indexedDb
                var registryIdentifier = vm.$root.getRegistryIdentifier();
                var registry_record = registryCollection.find({"name" : registryIdentifier});
                
                var idb;
                //carico subito l'IDb
                vm.loadLoki(registryIdentifier, "indexedAdapter", true, false).then((dbreg)=>{
                    idb = dbreg;
                    //se è la prima volta, risolvo subito questa promise (-> vado nello then)
                    if(!registry_record || registry_record.length == 0){
                        vm.loadRegistryAction(null, idb, registryCollection, registryIdentifier).then(() => {
                            registryResolve(idb);
                        })
                    }else{ //se non è la prima volta, risolvo subito questa promise (-> vado nello then) e risolvo anche la promise del registry
                        console.log("RESOLVING")
                        this.registry_record = registry_record;
                        this.registryStillToBeLoaded = true;
                        registryResolve(idb);
                    }            
                },(err) => {
                    console.log('error loading Idb', err)
                    registryReject();
                })
                    
                console.log('dataReferences loki db initialized', res)
            }, (err) => {
                console.log('error loadDatabase dataReferences', err)
            }));
    
            //____________________________________________________DB Modelli:____________________________________________________________________________________________
            //promises.push(this.loadLoki('/../static/data/' + vm.$root.token.modelsDb, "fs", false, false).then((res) => {
            promises.push(this.loadLoki(vm.$root.msPath +"/"+ vm.$Configs.licenseId +"/mod/" + vm.$root.token.modelsDb, "fs", false, false).then((res) => {
                vm.setLoadingMessage(this.$Jed.firstUpperTranslate('models database loaded', null)+'...')
                vm.$root.dbModels = res
                console.log('dbModel loki db loaded', res)
            }, (err) => {
                console.log('error loadDatabase dbModel', err)
            }));
    
            //____________________________________________Controllo catalogo pre caricato:____________________________________________________________________________________________
            //se abilitata preferenza OFFLINE, devo creare il loki per il catalogo pre caricato
            var behav = this.$Behaviors;
            var cr = localStorage.getItem("current_root");
            var c = localStorage.getItem("current");
            var cn = localStorage.getItem("current_name");
            var clm = localStorage.getItem("current_loaded_model")
            this.$root.root_index = cr != null && cr != "" ? cr : this.$root.root_index;
            this.$root.index_as_root = c != null && c != "" ? c : this.$root.index_as_root;
            this.$root.root_filename = cn != null && cn != "" ? cn : this.$root.root_filename;
            this.$root.model_of_cat = clm != null && clm != "" ? clm : this.$root.model_of_cat;
            
            // sposto qui il controllo per verificare un catalogo pre-caricato, così posso già creare il Loki se necessario
            if (this.$root.root_index == null || this.$root.root_filename == null) {
                this.$root["openModalSelect"] = true;
                this.$root["emitGotIndex"] = false;
            } else if (this.$root.index_as_root != null) {
                this.$root["openModalSelect"] = false;
                this.$root["emitGotIndex"] = true;
            } else {            
                this.$root["openModalSelect"] = false;
                this.$root["emitGotIndex"] = false;
            }
    
            /* var toast = document.getElementById('createdRegNotification'); 
            iziToast.hide({}, toast); */
           
            Promise.all(promises).then((res) => {
                console.log("RESOURCE LOAD COMPLETE")
                vm.RESOURCE_LOAD_COMPLETE = true;
                vm.loading_screen.finish()
                try {
                    document.getElementsByClassName("pg-loading-screen pg-loading")[0].style.display = "none";
                } catch(err){
                    console.log("Error on ensure loadin_screen.finish", err)
                }
                // AT LOAD COMPLETE, INIT ITER NOTIFICATION MANAGER
                vm.$root.notificationManager.initUserNotificationManager();
                vm.$nextTick(function(){
                    eventBus.$emit("RESOURCE_LOAD_COMPLETE_EVENT")
                    //vm.$Sync.pollingChangesSerializeStart()
                })
                return vm.$root.dbRegistry;
            }, (err) => {
                console.log(err)
                vm.RESOURCE_LOAD_COMPLETE = false;
            }).then((idb) => {
                if(vm.registryStillToBeLoaded && vm.registry_record){
                    vm.loadRegistryAction(vm.registry_record, idb);  
                }
            });
        },
        loadRegistryAction(registry_record, idb, registryCollection, registryIdentifier){
            var vm = this;
            return new Promise(function(resolve, reject){
                vm.loadLoki(vm.$root.msPath +"/"+ vm.$Configs.licenseId +"/reg/" + vm.$root.token.registryCliente, "soloDestructured", false, false, null, true).then((reg) => {
                    console.log(reg)
                    vm.$root.dbServRegistry = reg;
                    vm.$root.simpleNotification("success", {
                        title: "", 
                        message: vm.$Jed.firstUpperTranslate("your data has been loaded") 
                    });
                    
                    var bef;
                    var restorePromises = [];
                    if(!registry_record || registry_record.length == 0){ //è la prima volta che carico il registry nell'IDb
                        var lastSync;
                        try {
                            lastSync = vm.$root.token.regCrDate && vm.$root.token.regCrDate != "" ? Number(vm.$root.token.regCrDate) : Date.now(); 
                        } catch(err){
                            console.log(err)
                            lastSync = Date.now();
                        }
                        registry_record = registryCollection.insert({"name": registryIdentifier, "lastSync": lastSync})

                        //cerco le collection bi-direzionali su registry (scaricato dal server)
                        var list = reg.listCollections()
                        for(var i = 0; i < list.length; i++){
                            var c = list[i];
                            var c_serv = reg.getCollection(c.name);

                            //TODO: if(!c_serv.disableChangesApi && !c_serv.disableMeta){ //è una collezione bidirezionale => la scrivo nell'IDb
                            if(c.name == 'productTypes' || c.name == 'machines' || c.name == 'availability'
                                || c.name == 'clients' || c.name == 'addresses' || c.name == 'users' || c.name == 'orders' || c.name == 'discounts'
                                || c.name == 'orderItems' || c.name == 'zones' || c.name == 'provinces' || c.name == 'attributes' || c.name == 'attrCategories'){ //è una collezione bidirezionale o una di quelle che servono all' "avvio" => la scrivo nell'IDb

                                var indexes = []
                                if(c_serv.binaryIndices){
                                    for(var prop in c_serv.binaryIndices){
                                        if(c_serv.binaryIndices[prop].name){
                                            indexes.push(prop);
                                        }
                                    }
                                }

                                var _TEST_ = c.name == "orders" || c.name == "orderItems" || c.name =="addresses" //TODO: remove, check RegistryDatabase in publisher
                                var options = {
                                    disableChangesApi: _TEST_ ? false : c_serv.disableChangesApi != false,
                                    disableMeta: _TEST_ ? false : c_serv.disableChangesApi != false,
                                    unique: c_serv.uniqueNames && c_serv.uniqueNames.length > 0 ? c_serv.uniqueNames : null,
                                    indices: indexes && indexes.length > 0 ? indexes : null
                                }

                                var idb_coll = idb.addCollection(c.name, options);
                                var cloning = c_serv.data.slice();
                                idb_coll.data = cloning;
                                //ricostruisco gli indici e gli id della collection 
                                restorePromises.push(vm.restoreCollection(idb_coll).then(() => {
                                    // do nothing, handled in promise ALL
                                }))
                            }
                        } 
                    }else{ //registry già caricato precedentemente nell'IDb => scrivo su IDb le collection bi-dir del registry 
                        registry_record = registry_record[0];
                            
                        bef = Date.now();
                        //prendo le collezioni dall'IDb
                        var idblist = idb.listCollections()
                        
                        //itero sulle collezioni dell'IDb
                        for(var i = 0; i < idblist.length; i++){
                            var idbc = null, idbc_obj = null; 
                            idbc = idblist[i];
                            idbc_obj = idb.getCollection(idbc.name);
                            //uso il nome della collezione corrente per recuperare la stessa collezione però da registry 
                            var reg_c = reg.getCollection(idbc.name);
                            
                            restorePromises.push(new Promise(function(resolve, reject){
                                var worker = new Worker('../../static/js/copyWorker.js');
                                worker.addEventListener('message', function (e) {
                                    //copio la collezione del registry nell'IDb
                                    if(e.data.cn == idbc_obj.name){
                                        idbc_obj.data = e.data.c;
                                        
                                        worker.terminate();
                                        worker = undefined;
                                        //ricostruisco gli indici e gli id della collection 
                                        vm.restoreCollection(idbc_obj).then(() => {
                                            resolve();
                                        })
                                    }
                                });
                                worker.postMessage({d: reg_c.data, n: idbc.name});
                            }))
                        }
                    }
                    //  HANDLE PROMISE ALL
                    if(restorePromises.length > 0){
                        Promise.all(restorePromises).then(() => {
                            idb.saveDatabase(function(err){
                                if(err){
                                    console.log("error saving bi-dir collections in IDb: ", err)
                                } 
                                console.log('bidirectional collections correctly written in IDb', idb)
                                vm.$root.dbRegistry = idb;
                                if(!vm.$Configs.ecp.ecidUrl){
                                    vm.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
                                }
                                resolve();
                            });    
                        })
                    } else {
                        idb.saveDatabase(function(err){
                            if(err){
                                console.log("error saving bi-dir collections in IDb: ", err)
                            } 
                            console.log('bidirectional collections correctly written in IDb', idb)
                            vm.$root.dbRegistry = idb;
                            if(!vm.$Configs.ecp.ecidUrl){
                                vm.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
                            }
                            resolve();
                        });    
                    }
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/AppOfflineLoaderMixin.js